// extracted by mini-css-extract-plugin
export default {"recordCount":"RecordCount_recordCount__CmZKz"};